import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Form } from "@angular/forms";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth-service/auth.service";
import { sweetAlert } from "../../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { PrimaryDiagnosisService } from "../primary-diagnosis-service/primary-diagnosis.service";


@Component({
  selector: 'app-add-primary-diagnosis',
  templateUrl: './add-primary-diagnosis.component.html',
  styleUrls: ['./add-primary-diagnosis.component.css']
})
export class AddPrimaryDiagnosisComponent implements OnInit {
  primaryDiagnosisForm: UntypedFormGroup;
  submitted = false;
  userId = null;
  primaryDiagnosisId;
 
  constructor(
    public authService: AuthService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private activatedRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private router: Router,
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      this.primaryDiagnosisId = params["id"];
      if(this.primaryDiagnosisId){
        this.getPrimaryDiagnosebyId();
      }
    });

    this.primaryDiagnosisForm = this.fb.group({
      title: ["", Validators.required],
      code: ["", Validators.required],
      status: ['active', Validators.required]
    });
  }

  getPrimaryDiagnosebyId(){
    this.primaryDiagnosisService.getPrimaryDiagnoseById(this.primaryDiagnosisId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.primaryDiagnosisForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  savePrimaryDiagnose() {
    this.submitted = true;
    if (this.primaryDiagnosisForm.invalid) {
      return;
    }
      let payload = this.primaryDiagnosisForm.value;
      this.primaryDiagnosisService.saveprimaryDiagnose(this.primaryDiagnosisId,payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("billing/primary-diagnosis");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  get form() {
    return this.primaryDiagnosisForm.controls;
  }

  ngOnDestroy(): void {
  }
}
